import { tyreLabelAttrs } from 'Components/02-molecules/tyre-labels/models/labels.js';

export const isTypeLabel = (id) => Object.keys(tyreLabelAttrs).includes(id);
